<template>
  <section>
    <div class="container">
      <h2 class="dotTop">Press &amp; Awards</h2>
      <div class="pressItems">
        <press-item v-for="(item, index) in pressItems" :item="item" :key="index"></press-item>
      </div>
      <div class="text-center" v-if="expandable">
        <button @click="toggleExpanded" class="button button-color button-yellow">{{ expanded ? 'Show Less' : 'More Press Announcements' }}</button>
      </div>
    </div>
  </section>
</template>

<script>
import PressItem from './PressItem'

export default {
  name: 'press',
  data () {
    return {
      expanded: false
    }
  },
  props: ['items'],
  components: {
    PressItem
  },
  methods: {
    toggleExpanded () {
      this.expanded = !this.expanded
    }
  },
  computed: {
    expandable () {
      return this.items && (this.items.length > 6)
    },
    pressItems () {
      if (this.expandable && !this.expanded) {
        return this.items.slice(0, 6)
      } else {
        return this.items
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
  @import ../../assets/styles/colors
  @import ../../assets/styles/mixins

  section
    padding-top: 50px
    padding-bottom: 58px
    .dotTop
      margin-bottom: 48px
      &:before
        background-color: $yellow
    .pressItems
      margin-bottom: 20px
      +tablet
        display: flex
        flex-wrap: wrap
</style>



// WEBPACK FOOTER //
// Press.vue?006a1a2a